/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetUbiAppResponse } from '../models/ApiResponseGetUbiAppResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UbiAppControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 안전운전점수 상세
   * @returns ApiResponseGetUbiAppResponse OK
   * @throws ApiError
   */
  public getUbi({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetUbiAppResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ubi',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 상세
   * @returns ApiResponseGetUbiAppResponse OK
   * @throws ApiError
   */
  public getUbi1({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetUbiAppResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ubi/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
}
